let loading = null;

export const loadSnap = ({snap_js, client_key}) => {
  if (window.snap) return Promise.resolve(window.snap);
  if (!loading) loading = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = snap_js;
    s.setAttribute("data-client-key", client_key);
    s.onload = () => resolve(window.snap);
    s.onerror = () => { loading = null; reject(new Error("snap")); };
    document.body.appendChild(s);
  });
  return loading;
};

export const paySnap = async (config, token, onDone) => {
  const snap = await loadSnap(config);
  snap.pay(token, {language: "id", onSuccess: onDone, onPending: onDone, onError: onDone, onClose: onDone});
};
